import { Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const SectionTitle = styled(Typography).attrs((props) => ({
  color: "white",
  fontSize: { _: "20px", tablet: "16px" },
  fontWeight: "600",
  lineHeight: "124%",
  textTransform: "uppercase",
  ...props,
}))``

export const FooterLink = styled(Typography).attrs((props) => ({
  as: Link,
  color: "white",
  fontSize: { _: "20px", tablet: "16px" },
  fontWeight: { _: "400", tablet: "500" },
  py: { _: "6px", tablet: "4px" },
  ...props,
}))`
  align-items: center;
  display: flex;
  line-height: 100%;
  &:hover {
    color: ${(props) => props.theme.colors.grey[10]};
    text-decoration: underline;
  }
  &:focus {
    color: ${(props) => props.theme.colors.grey[10]};
    text-decoration: none;
    outline-color: ${(props) => props.theme.colors.white};
  }
`
